import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { UsePaginationState } from '@uhg-abyss/web/hooks/usePagination';
import { Pagination } from '@uhg-abyss/web/ui/Pagination';
import React from 'react';

import { Styles } from './includes/styles';

type CompactPaginationProps = {
  pagination: UsePaginationState;
};

/**
 * CompactPagination
 *
 * Displays a pagination control for next/previous pages along with the current page number and total page number.
 */
export function CompactPagination({
  pagination = {
    canNextPage: false,
    canPreviousPage: false,
    firstPage(): void {},
    goToPage(pageNumber: number): void {},
    gotoPage(pageNumber: number): void {},
    lastPage(): void {},
    nextPage(): void {},
    pageCount: 0,
    pageIndex: 0,
    previousPage(): void {},
    setData(value: React.SetStateAction<object[]>): void {},
    state: {
      currentPage: 0,
      pageCount: 0,
      pageIndex: 0,
      rowCount: 0,
      rows: [],
    },
  },
}: CompactPaginationProps) {
  return (
    <ErrorHandler location="src/shared/ui/components/TableQuery/components/Header/components/CompactPagination/CompactPagination.tsx">
      <Styles>
        <Pagination {...pagination} variant="compact" />
      </Styles>
    </ErrorHandler>
  );
}
